export default class Queue {
  constructor (concurrency = 1) {
    this.concurrency = concurrency
    this.running = 0
    this.tasks = []
  }

  async enqueue (task) {
    this.tasks.push(task)
    if (this.running >= this.concurrency) return

    ++this.running
    while (this.tasks.length) {
      try {
        await this.tasks.shift()()
      } catch (err) {
        console.error(err)
      }
    }
    --this.running
  }

  clear () {
    this.tasks = []
    this.running = 0
  }
}
